import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReloadService {
    private _reload = new Subject<void>();
    readonly reload$ = this._reload.asObservable();

    trigger() {
        this._reload.next();
    }
}
